<app-inward-table></app-inward-table>